import { ListProps } from "./userProfileInfoType";


function UserActionPanel({ children }: ListProps) {

    const logout = (): void => {
        // window.localStorage.clear();
        // window.history.pushState(null,'','/?token=&id=') // preserve app state
        window.location.href = "/?token=&id=";
    }

    return (
        <>
            <div className='boxes-contener'>
                <div className='text-box'>
                    <div className='text-box-header'>Działania</div>
                    <div className='user-data-table'>

                        <div className='user-data-table-row'>
                            <div className='user-data-table-row-key'>
                                <p>zmień motyw</p>
                            </div>
                            <div className='user-data-table-row-value'>
                                {children}
                            </div>
                        </div>

                        <div className='user-data-table-row'>
                            <div className='user-data-table-row-key'>
                                <p>wyloguj</p>
                            </div>
                            <div className='user-data-table-row-value'>
                                <button onClick={() => logout()} className="submit">
                                    <img src="/icons/right-from-bracket-solid.svg" alt="wyloguj" className="img"></img>
                                    wyloguj
                                </button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserActionPanel;